import React from 'react'
import propTypes from 'prop-types'
import { ButtonBase } from '@mui/material'
import styled from '@emotion/styled'
import { ReactSVG } from 'react-svg'
import close from '../../../assets/icons/close-grey.svg';
import { theme } from '../../../themes/default-theme'

const Button = styled(ButtonBase)`
    background-color: white;
    color: ${theme.palette.gunmentalGrey};
    border: 1px solid ${theme.palette.gunmentalGrey};
    padding: 5px 24px 6px 11px;
    position: relative;
    font-size: 12px;
    border-radius: 22px;
    text-transform: capitalize;

    svg {
        position: absolute;
        right: 11px;
        width: 7px;
        height: 7px;
        top: 10px;
    }

`

const FilterItem = ({
    onClick,
    title
}) => {
    return (
    	<Button onClick={onClick}>
            {title.split('-').join(' ')}
            <ReactSVG src={close} />
        </Button>
    )
}

FilterItem.propTypes = {
}

export default FilterItem